import React from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import 'normalize.css'
import { useAnalytics } from 'reactfire'

// Views
import Landing from 'src/views/Landing/Landing'
import LogIn from 'src/views/LogIn'
import Profile from 'src/views/Profile'
import SignUp from 'src/views/SignUp'
import Quiz from 'src/views/Quiz/Quiz'
import CompletedQuizzes from 'src/views/Quizzes/CompletedQuizzes'
import NewQuizzes from 'src/views/Quizzes/NewQuizzes'
import { QuizResults } from 'src/views/QuizResults/QuizResults'
import { Leaderboard } from 'src/views/Leaderboard/Leaderboard'
import { LeaderBoardDetail } from 'src/views/LeaderBoardDetail/LeaderBoardDetail'
import { Notifications } from 'src/views/Notifications/Notifications'
import { Terms } from 'src/views/Terms/Terms'
import { Privacy } from 'src/views/Privacy/Privacy'
// Other
import * as routes from 'src/constants/routes'
import { useResolveAuth } from 'src/hooks/useResolveAuth'

export const App: React.FC = () => {
  useAnalytics()
  useResolveAuth()

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={routes.LANDING} component={Landing} />
        <Route path={routes.EMAIL_LOGIN} component={LogIn} />
        <Route path={routes.PROFILE} component={Profile} />
        <Route path={routes.SIGN_UP} component={SignUp} />

        <Route
          exact
          path={routes.QUIZZES}
          component={() => <Redirect to={routes.QUIZZES_NEW} />}
        />
        <Route path={routes.NEW_QUIZ} component={Quiz} />
        <Route path={routes.QUIZZES_NEW} component={NewQuizzes} />
        <Route path={routes.COMPLETE_QUIZ} component={QuizResults} />
        <Route
          path={routes.QUIZZES_COMPLETED}
          exact
          component={CompletedQuizzes}
        />
        <Route path={routes.LEADER_BOARD} component={Leaderboard} exact />
        <Route
          path={routes.LEADER_BOARD_DETAIL}
          component={LeaderBoardDetail}
          exact
        />
        <Route path={routes.NOTIFICATIONS} component={Notifications} />
        <Route path={routes.TERMS} component={Terms} />
        <Route path={routes.PRIVACY} component={Privacy} />
        <Redirect to={routes.LANDING} />
      </Switch>
    </BrowserRouter>
  )
}

export default App
